
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.237 18.375c.27 0 .488.238.488.531 0 .261-.173.478-.4.523l-.088.009-1.323-.001-.63.645a.965.965 0 01-.69.293H4.356a.965.965 0 01-.69-.293l-.631-.645H1.713a.5.5 0 01-.48-.435l-.008-.096c0-.26.173-.477.4-.522l.088-.009h19.524zm-1.762-14.75c.291 0 .52.23.499.5l-.145 1.754c.17.008.339.025.503.052 1.46.24 2.443 1.23 2.443 2.795 0 1.595-1.255 3.025-3.7 4.377-.723 2.058-2.804 3.522-5.23 3.522h-4.74c-2.874 0-5.263-2.055-5.484-4.715l-.645-7.785c-.022-.27.208-.5.499-.5zm.221 3.85l-.294 3.552c1.191-.822 1.773-1.602 1.773-2.301 0-.724-.369-1.096-1.103-1.217a2.678 2.678 0 00-.376-.033z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    